module.exports = __webpack_public_path__ + "static/media/adis.6ebc4f3c.png";